export default "__VITE_ASSET__e48d372b__"